import React, { useState } from "react";
import { ClipboardList, Send, Wallet } from "lucide-react";
import TransfertsView from "../../../../components/features/administration/transactions/TransactionsView";
import RechargementsView from "../../../../components/features/administration/transactions/RechargmentsView";
import TransactionTrackingView from "../../../../components/features/administration/transactions/TransactionTrackingView";

// Nouveau type pour le type de transaction
type TransactionType = "transfer" | "deposit" | "tracking";

const TransactionsPage: React.FC = () => {
  const [transactionType, setTransactionType] = useState<TransactionType>("transfer");

  return (
    <>
      <div className="mb-8">
        <h1 className="mb-2 text-3xl font-bold text-gray-800">Transactions</h1>
        <p className="text-gray-600">Suivi et gestion des transferts et rechargements</p>
      </div>
      {/* 🎯 Nouveaux onglets : Transferts / Rechargements */}
      <div className="mb-6">
        <div className="flex gap-3 p-1 bg-gray-100 rounded-xl w-fit">
          <button
            onClick={() => setTransactionType("transfer")}
            className={`
              flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all
              ${
                transactionType === "transfer"
                  ? "bg-white text-blue-600 shadow-md"
                  : "text-gray-600 hover:text-gray-800"
              }
            `}
          >
            <Send className="w-5 h-5" />
            Transferts d'argent
          </button>
          <button
            onClick={() => setTransactionType("deposit")}
            className={`
              flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all
              ${
                transactionType === "deposit"
                  ? "bg-white text-purple-600 shadow-md"
                  : "text-gray-600 hover:text-gray-800"
              }
            `}
          >
            <Wallet className="w-5 h-5" />
            Rechargements Wallet
          </button>

          <button
            onClick={() => setTransactionType("tracking")}
            className={`
              flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all
              ${
                transactionType === "tracking"
                  ? "bg-white text-green-600 shadow-md"
                  : "text-gray-600 hover:text-gray-800"
              }
            `}
          >
            <ClipboardList className="w-5 h-5" />
            Suivi Transactions
          </button>
        </div>
      </div>
      {transactionType === "transfer" ? (
        <TransfertsView />
      ) : transactionType === "deposit" ? (
        <RechargementsView />
      ) : (
        <TransactionTrackingView />
      )}{" "}
    </>
  );
};

export default TransactionsPage;
